var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"loader-container bg-cl-secondary absolute"},[_c('div',{staticClass:"loader-inner-container absolute"},[_c('Spinner')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }